import { FormErrors } from "redux-form";
import {
    required,
    validInputLength,
    validTaxationNumber,
} from "../../../util/validators";
import { KYCDataDto, TaxationData } from "util/DTOs/KYCDtos";

const validateKYCForm = (values: KYCDataDto) => {
    const errors: any = {};

    validateBasicInfo(values, errors);
    validateTaxInfo(values, errors);
    validatePaymentInformation(values, errors);

    errors.customerConfirmsGivenDataIsTrue = required(
        values.customerConfirmsGivenDataIsTrue
    );

    return errors;
};

const validateSelectionList = (values: string[]) => {
    const selectionListerrors: any[] = [];
    values.forEach((v, idx) => {
        if (!v) {
            selectionListerrors[idx] = required(v);
        }
    });
    return selectionListerrors;
};

const validateBasicInfo = (values: KYCDataDto, errors: any) => {
    errors.servicesInUseInHypo = required(values.servicesInUseInHypo);
    errors.countriesWithBankingRelationships =
        values.countriesWithBankingRelationships &&
        validateSelectionList(values.countriesWithBankingRelationships);
    errors.countryOfResidence = required(values.countryOfResidence);
    errors.countryOfBirth = required(values.countryOfBirth);
    errors.politicallyExposedReason =
        values.politicallyExposed && required(values.politicallyExposedReason);
};

const validateTaxInfo = (values: KYCDataDto, errors: any) => {
    errors.taxablePersonInFinland = required(values.taxablePersonInFinland);
    values.countriesWithTaxation &&
        validateCountriesWithTaxation(values.countriesWithTaxation, errors);
    errors.usIsNotCustomersCountryOfTaxResidence = required(
        values.usIsNotCustomersCountryOfTaxResidence
    );
    errors.nationalities =
        values.nationalities && validateSelectionList(values.nationalities);

    validateOriginOfFunds(values, errors);
};

const validateCountriesWithTaxation = (values: TaxationData[], errors: any) => {
    const countriesWithTaxationErrors: FormErrors<TaxationData>[] = [];
    values.forEach((v) => {
        const countriesWithTaxationErrorsSingle: FormErrors<TaxationData> = {};

        if (v && v.taxationCountry) {
            countriesWithTaxationErrorsSingle.taxationNumber =
                required(v.taxationNumber) ||
                validInputLength(v.taxationNumber, 20, "Verotunnisteen") ||
                validTaxationNumber(v.taxationNumber);

            //NOTE(tonim): Disabled until taxationNumberNotGranted is implemented in cLA
            // if (!v.taxationNumberNotGranted) {
            //     countriesWithTaxationErrorsSingle.taxationNumber =
            //         required(v.taxationNumber) ||
            //         validInputLength(v.taxationNumber, 20, "Verotunnisteen") ||
            //         validTaxationNumber(v.taxationNumber);
            // }
            // if (!v.taxationNumber) {
            //     countriesWithTaxationErrorsSingle.taxationNumberNotGranted = required(
            //         v.taxationNumberNotGranted
            //     );
            // }
        }
        countriesWithTaxationErrors.push(countriesWithTaxationErrorsSingle);
    });

    errors.countriesWithTaxation = countriesWithTaxationErrors;
};

const validateOriginOfFunds = (values: KYCDataDto, errors: any) => {
    if (
        !values.originOfFundsEarnings &&
        !values.originOfFundsInvestments &&
        !values.originOfFundsSaleOfProperty &&
        !values.originOfFundsGift &&
        !values.originOfFundsBusinessIncome
    ) {
        errors.customerHasNoAssets = required(values.customerHasNoAssets);
        errors.originOfFundsEarnings = required(values.originOfFundsEarnings);
        errors.originOfFundsInvestments = required(
            values.originOfFundsInvestments
        );
        errors.originOfFundsSaleOfProperty = required(
            values.originOfFundsSaleOfProperty
        );
        errors.originOfFundsGift = required(values.originOfFundsGift);
        errors.originOfFundsBusinessIncome = required(
            values.originOfFundsBusinessIncome
        );
    }
    if (values.customerHasNoAssets) {
        errors.originOfFundsEarnings = undefined;
        errors.originOfFundsInvestments = undefined;
        errors.originOfFundsSaleOfProperty = undefined;
        errors.originOfFundsGift = undefined;
        errors.originOfFundsBusinessIncome = undefined;
    }
};

const validatePaymentInformation = (values: KYCDataDto, errors: any) => {
    errors.incomingOutgoingForeignPaymentsPcs =
        values.incomingOutgoingForeignPayments &&
        required(values.incomingOutgoingForeignPaymentsPcs);
    errors.incomingOutgoingForeignPayments =
        values.incomingOutgoingForeignPaymentsPcs &&
        required(values.incomingOutgoingForeignPayments);
    if (
        values.incomingOutgoingForeignPayments &&
        values.incomingOutgoingForeignPayments !== "0" &&
        values.incomingOutgoingForeignPaymentsPcs &&
        values.incomingOutgoingForeignPaymentsPcs !== "0"
    ) {
        errors.incomingOutgoingForeignPaymentsCountries =
            values.incomingOutgoingForeignPaymentsCountries &&
            validateSelectionList(
                values.incomingOutgoingForeignPaymentsCountries
            );
    }
};

export default validateKYCForm;



// WEBPACK FOOTER //
// ./src/views/profile/components/KYCFormValidator.ts